import * as _ from 'lodash';

export const MIN_CUSTOM_SEVERITY = 0;
export const MAX_CUSTOM_SEVERITY = 100;

export const isValidCustomSeverity = (severity: number): boolean =>
  _.isNumber(severity) &&
  Number.isInteger(severity) &&
  severity >= MIN_CUSTOM_SEVERITY &&
  severity <= MAX_CUSTOM_SEVERITY;

export enum VulnSeverityMapping {
  LOW,
  MEDIUM,
  UNKNOWN,
  HIGH,
  CRITICAL,
}

export const vulnSeverityMappingToString = (severity: VulnSeverityMapping) => {
  return (severity in VulnSeverityMapping ?
    VulnSeverityMapping[severity] :
    VulnSeverityMapping[VulnSeverityMapping.UNKNOWN]).toLowerCase();
};

export const getSeverityFromCVSS = (cvss?: number | null): VulnSeverityMapping => {
  if (!_.isNumber(cvss) || cvss < 0 || cvss > 10) {
    return VulnSeverityMapping.UNKNOWN;
  }
  if (cvss >= 0 && cvss <= 3.9) {
    return VulnSeverityMapping.LOW;
  }
  if (cvss <= 6.9) {
    return VulnSeverityMapping.MEDIUM;
  }
  if (cvss <= 8.9) {
    return VulnSeverityMapping.HIGH;
  }
  return VulnSeverityMapping.CRITICAL;
};
